var env_data = {};(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

$.prototype.positionFixSidebar = function () {
  var $mainContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var minWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (this.length === 0) return;

  var positionFixSidebar = function positionFixSidebar($block, $mainContainer, minWidth) {
    function setPositionSidebar($block, $mainContainer, minWidth) {
      var $container = $mainContainer === false ? $block.parent() : $mainContainer;
      var lengthMainContainer = $container.height() - $block.height() + $container.offset().top;
      var parent = $block.parent();
      var parentTop = $(parent).offset().top;
      var parentWidth = $(parent).width();
      var stickyHeader = $('.block.block-header');
      var stickyHeight = stickyHeader.height() + 15;
      $container.css({
        'position': 'relative'
      });
      $block.css({
        'width': parentWidth + "px"
      });

      if ($(window).width() > minWidth) {
        var scroll = $(window).scrollTop();
        var height = $block.height() + 'px';
        $container.css({
          'position': 'relative'
        });

        if (scroll < $(parent).offset().top) {
          $(parent).css({
            'position': 'relative'
          });
          $block.css({
            'position': 'absolute',
            'top': '0',
            'width': parentWidth + "px"
          });
        } else if (scroll > lengthMainContainer) {
          $(parent).css({
            'position': 'initial'
          });
          $block.css({
            'position': 'absolute',
            'bottom': '0',
            'top': 'auto'
          });
        } else {
          $block.css({
            'position': 'fixed',
            'top': stickyHeight,
            'height': height
          });
        }
      } else {
        $block.css({
          'position': 'relative',
          'bottom': 'initial',
          'top': 'initial',
          'width': "100%"
        });
      }
    }

    $(window).scroll(function () {
      setPositionSidebar($block, $mainContainer, minWidth);
    });
    $(document).ready(function () {
      setPositionSidebar($block, $mainContainer, minWidth);
    });
    $(window).resize(function () {
      setPositionSidebar($block, $mainContainer, minWidth);
    });
  };

  for (var i = this.length - 1; i >= 0; i--) {
    new positionFixSidebar($(this[i]), $mainContainer, minWidth);
  }
};

function centerWrapperPadding() {
  var centerWrapper = $(".center-wrapper");
  var stickyHeader = $('.block.block-header');
  var stickyHeight = stickyHeader.height() + 15;

  if (0 !== centerWrapper.length && 0 !== stickyHeader.length) {
    centerWrapper.css("padding-top", stickyHeight);
  }
}

function headerFix() {
  var scroll = $(window).scrollTop();

  if (scroll >= stickyOffset) {
    stickyHeader.addClass('fixed');
  } else {
    stickyHeader.removeClass('fixed');
  }
}

function setActiveNotesToggleButton(notesToggleBlock, postType) {
  var notesToggleButtons = $(notesToggleBlock).find(".notes-toggle-buttons");
  var notesToggleButton = $(notesToggleButtons).find(".notes-toggle-button[data-post-type='" + postType + "']");
  var notesToggleContent = $(notesToggleBlock).find(".notes-toggle-content");
  var notesToggleButtonSplash = $(notesToggleButtons).find(".notes-toggle-button-splash");

  if (0 !== $(notesToggleButtons).length) {
    $(notesToggleButtons).find(".notes-toggle-button").removeClass('current-cat');
    $(notesToggleButtons).find(".notes-toggle-button[data-post-type='" + postType + "']").addClass('current-cat');

    if (0 !== $(notesToggleButtonSplash).length) {
      $(notesToggleButtonSplash).css({
        "left": $(notesToggleButton).position().left,
        "width": $(notesToggleButton).innerWidth(),
        "height": $(notesToggleButton).innerHeight(),
        "border-radius": $(notesToggleButton).css("border-radius")
      });
    }
  }

  if (0 !== $(notesToggleContent).length) {
    $(notesToggleContent).find(".notes-toggle-item").removeClass('current-cat');
    $(notesToggleContent).find(".notes-toggle-item[data-post-type='" + postType + "']").addClass('current-cat');
  }
}

var stickyHeader = $('.block.block-header');
var stickyOffset = stickyHeader.offset().top;
var stickyHeight = stickyHeader.height();
var notesToggleBlock = $(".notes-toggle");
var postType = notesToggleBlock.find(".notes-toggle-button").first().data("postType");
$(window).scroll(function () {
  headerFix();
});
$(window).on("resize", function () {
  centerWrapperPadding();
  headerFix();
});
$(document).ready(function () {
  centerWrapperPadding();
  headerFix();
  setActiveNotesToggleButton(notesToggleBlock, postType);
  $(".block-share").positionFixSidebar($(".block-post"));
  $(".block-sidebar-posts").positionFixSidebar($(".block-post"), 992);
  $(".bank-image-inner").positionFixSidebar($(".bank-info"), 767);
  $('.header-menu-mobile-btn, .header-menu-mobile-contents .close-btn').on('click', function (e) {
    $(".header-menu-mobile-contents").toggleClass("open");
  });
});
$(document).on("scroll", function () {
  var pixels = $(document).scrollTop();
  var pageHeight = $(document).height() - $(window).height();
  var progress = 100 * pixels / pageHeight;
  $("#progress-page").css("width", progress + "%");
});
$(document).on('click', 'a[href^="#"]', function (e) {
  // target element id
  var id = $(this).attr('href'); // target element

  var $id = $(id);

  if ($id.length === 0) {
    return;
  } // prevent standard hash navigation (avoid blinking in IE)


  e.preventDefault(); // top position relative to the document

  var pos = $id.offset().top; // animated top scrolling

  $('body, html').animate({
    scrollTop: pos
  });
});
$(document).on('click', '.notes-toggle-button a', function (e) {
  e.preventDefault();
  var btn = $(this).closest(".notes-toggle-button");
  var notesToggleBlock = btn.closest(".notes-toggle");
  var notesToggleContent = $(notesToggleBlock).find(".notes-toggle-content");
  var postType = btn.data("postType");
  var currentNotesToggleItem = $(notesToggleContent).find(".notes-toggle-item[data-post-type='" + postType + "']");

  if (0 !== $(notesToggleContent).length) {
    setActiveNotesToggleButton(notesToggleBlock, postType);

    if (0 !== $(currentNotesToggleItem).length && $(currentNotesToggleItem).find(".items").is(':empty')) {
      /*$.ajax({
         url: "/wp-admin/admin-ajax.php",
        data: {
          'action':'get-posts-popular'
        },
        datatype: "html",
        type: "post",
         beforeSend:function(){
           $(currentNotesToggleItem).find(".loading_items").addClass("active");
         },
         success:function(response){
           $(currentNotesToggleItem).find(".loading_items").removeClass("active");
          $(currentNotesToggleItem).find(".items").append(response);
        }
      });*/
    }
  }
});

},{}]},{},[1]);
